import { render, staticRenderFns } from "./CreditScores.vue?vue&type=template&id=2c4943b6&scoped=true&"
import script from "./CreditScores.vue?vue&type=script&lang=js&"
export * from "./CreditScores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4943b6",
  null
  
)

export default component.exports